import type { ZodSchema } from 'zod';
import { validateSchema } from './validateSchema';

export const validateApiRequest = <S extends ZodSchema>(schema: S) => validateSchema(schema);
